var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse23(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 114,
    viewBox: "0 0 118 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_642_6520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.5 57C83.5 69.7025 72.531 80 59 80C45.469 80 34.5 69.7025 34.5 57C34.5 44.2975 45.469 34 59 34C72.531 34 83.5 44.2975 83.5 57Z",
    fill: "#FCD64A",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_642_6520",
    x: 0.5,
    y: 0,
    width: 117,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17,
    result: "effect1_foregroundBlur_642_6520"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse23);
export default __webpack_public_path__ + "static/media/ellipse23.21111cdcf04510c430f49e99f48f42c5.svg";
export { ForwardRef as ReactComponent };